<template>
  <div class="overflow-hidden">
    <AgentsHero />
    <AgentsPartners />
    <LazyAgentsProblemSlider />
    <LazyAgentsTierLadder />
    <LazyAgentsPayoutFeature />
    <LazyAgentsAmSection />
    <LazyAgentsFeaturesGrid />
    <LazyAgentsHowItWorks />
    <LazyAgentsReferralProgram />
    <LazyAgentsComparison />
    <LazyAgentsFaq />
  </div>
</template>

<script setup lang="ts">
// The International landing, rendered on / (what crawlers see) and /international (where visitors land).
const { t } = useI18n();
const { topSelfClosePercent } = useLandingFacts();

const description = () =>
  topSelfClosePercent.value === null
    ? t('landing.seo.descriptionFallback')
    : t('landing.seo.description', { percent: topSelfClosePercent.value });

useSeoMeta({
  title: () => t('landing.seo.title'),
  description,
  ogTitle: () => t('landing.seo.title'),
  ogDescription: description,
});
</script>
